export default __webpack_public_path__ + "static/media/assignquestions.b5c85b19.svg";